import { ProLightCirclePause } from '@nexelem/icons/ProLightCirclePause';
import { ProLightClock } from '@nexelem/icons/ProLightClock';
import { ProLightHourglassClock } from '@nexelem/icons/ProLightHourglassClock';
import { Badge, Status } from '@nexelem/components';
import { useCustomTranslation } from '../../../../../hooks';
import { KanbanTaskView, TaskStatus } from '@nexelem/graphne-api';
import { clsx } from 'clsx';
import { ProLightCircleExclamationCheck } from '@nexelem/icons/ProLightCircleExclamationCheck';
import { CUSTOM_ICONS } from '@nexelem/icons';
import { faThumbsDown } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

type KanbanStatusRowProps = {
  priority?: boolean;
  isBehindSchedule?: boolean;
  hasError?: boolean;
  isOverdue?: boolean;
  requiresAcceptance?: boolean;
  productionLotTags: KanbanTaskView['productionLotTags'];
  status?: KanbanTaskView['status'];
  showProductionLotTags?: boolean;
  wasPaused?: boolean;
  hasActiveDowntime?: boolean;
};

export const KanbanStatusRow = ({
  priority,
  isBehindSchedule,
  hasError,
  isOverdue,
  requiresAcceptance,
  productionLotTags = [],
  showProductionLotTags = false,
  wasPaused,
  hasActiveDowntime,
  status,
}: KanbanStatusRowProps) => {
  const { t, tWrapper } = useCustomTranslation('products.productionPlan');

  const hasAnyStatus =
    priority ||
    isBehindSchedule ||
    hasError ||
    isOverdue ||
    requiresAcceptance ||
    showProductionLotTags ||
    productionLotTags.length > 0 ||
    wasPaused ||
    hasActiveDowntime;
  if (!hasAnyStatus) {
    return null;
  }

  return (
    <div className="flex flex-wrap gap-2 text-nowrap">
      {priority && <CUSTOM_ICONS.PriorityFlag className="text-icon-brand" />}
      {isBehindSchedule && <FontAwesomeIcon className={clsx('min-h-6 min-w-6 text-icon-error')} icon={faThumbsDown} />}
      {hasError && <Status color="red" text={t('common.error')} variant="outlined" />}
      {status !== TaskStatus.Completed && wasPaused && (
        <Status color="grey" Icon={ProLightCirclePause} text={tWrapper('kanban.paused')} variant="contained" />
      )}
      {requiresAcceptance && (
        <Status
          color="orange"
          Icon={ProLightCircleExclamationCheck}
          text={t('productionLots.details.toAccept')}
          variant="contained"
        />
      )}
      {isOverdue && <Status color="red" Icon={ProLightClock} text={tWrapper('kanban.overdue')} variant="contained" />}
      {/* Kanban Shortage */}
      {hasActiveDowntime && (
        <Status color="grey" Icon={ProLightHourglassClock} text={tWrapper('kanban.downtime')} variant="contained" />
      )}
      {showProductionLotTags && productionLotTags.map((tag) => <Badge key={tag.id}>{tag.name}</Badge>)}
    </div>
  );
};
